import React from 'react';
import CtaFooter from '../ctaFooter/ctaFooter';
import ServicesContentCard from './servicesContentCard/servicesContentCard';

function Services() {
  return (
    <>
    
      <ServicesContentCard />

      <CtaFooter />
    </>
  )
}

export default Services